import { ResourceAppModule } from "@/shared/app";
import { plmApp } from "../app";
import {
  RodzajOpakowania,
  rodzajOpakowaniaResource,
} from "@megarax/client/src/resources/plm";

export const rodzajOpakowaniaModule: ResourceAppModule = {
  app: plmApp,
  formComponent: () => import("./ItemForm.vue"),
  sheetComponent: () => import("./ItemSheet.vue"),
  listComponent: () => import("./ItemList.vue"),
  title: "Rodzaje opakowań",
  route: "rodzajOpakowania",
  itemConstructor: RodzajOpakowania,
  resource: rodzajOpakowaniaResource,
};
